<form [formGroup]="propertyForm" class="contact-form" (ngSubmit)="onSubmit()">

    <ms-input-label [isRequired]="isFieldRequired('title')" [labelText]="'Title'" class="mt-3" />
    <input type="text" id="title" [required]="isFieldRequired('title')" maxlength="50" formControlName="title"
        class="form-control"
        [class.is-invalid]="propertyForm.get('title')?.invalid && propertyForm.get('title')?.touched"
        [class.is-valid]="propertyForm.get('title')?.valid && propertyForm.get('title')?.touched && propertyForm.get('title')?.value !== ''" />
    @if(propertyForm.get('title')?.invalid && propertyForm.get('title')?.touched) {
    <div class="error-messages">
        @if(propertyForm.get('title')?.errors?.['required']) {
        <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.TitleRequired}}</p>
        }
    </div>
    }

    <div class="form-check text-start mt-3 mb-3">
        <input type="checkbox" class="form-check-input" id="noStreetAddress"
            [checked]="noStreetAddress()"
            (change)="toggleNoStreetAddress()" />
        <label class="form-check-label" for="noStreetAddress">
            No street address available
        </label>
    </div>

    <ms-address-form formControlName="address" [countryTooltip]="countryTooltip()"
        [required]="isFieldRequired('address')" [hidden]="noStreetAddress()" />

    <ms-input-label [isRequired]="isFieldRequired('lotNumber')" [labelText]="'Lot Number'" class="mt-3" />
    <input type="text" id="lotNumber" [required]="isFieldRequired('lotNumber')" maxlength="20"
        formControlName="lotNumber" class="form-control"
        [class.is-invalid]="propertyForm.get('lotNumber')?.invalid && propertyForm.get('lotNumber')?.touched"
        [class.is-valid]="propertyForm.get('lotNumber')?.valid && propertyForm.get('lotNumber')?.touched && propertyForm.get('lotNumber')?.value !== ''" />
    @if(propertyForm.get('lotNumber')?.invalid && propertyForm.get('lotNumber')?.touched) {
    <div class="error-messages">
        @if(propertyForm.get('lotNumber')?.errors?.['required']) {
        <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.LotNumberRequired}}</p>
        }
    </div>
    }

    <div class="d-flex justify-content-end mt-5">
        <button type="button" class="btn btn-ms-secondary me-3" (click)="onCancel()">
            Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting()">
            @if(isSubmitting()) {
            <div class="spinner-border text-light spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            } @else {
            {{ formState() === FormState.Update ? 'Save' : 'Submit' }}
            }
        </button>
    </div>

</form>
